import React, { useState, useEffect } from 'react';
import _ from 'lodash';

import { InputTextarea } from 'primereact/inputtextarea';

import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import RadioButton from 'components/radio-button';
import Title from 'components/title';
import {
    RejectionReason,
    Rejection,
    useSetRejectionMutation
} from 'generated/graphql';
import { getLoanApplicationParams, validateObject } from 'utils/utils';
import { useNavigation } from 'hooks/index';
import ThanksFeedbackPage from './thanks-feedback';
import HurryUpPage from './hurry-up';

const REASONS_WITH_NO_RETURN = [RejectionReason.InterestRate, RejectionReason.Value, RejectionReason.Tenure];
const rejection: Rejection = {};

const FeedbackPage: React.FC = () => {
    const { previousScreen } = useNavigation();
    const [showThanksFeedback, setShowThanksFeedback] = useState(false);
    const [showHurryUp, setShowHurryUp] = useState(false);
    const [setRejection] = useSetRejectionMutation();

    const [invalidFields, setInvalidFields] = useState([]);
    const [form, setForm] = useState(rejection);
    const [submitting, setSubmitting] = useState(false);
    const loanApplicationId = getLoanApplicationParams();

    const initializeForm = () => {
        setForm(rejection);
        setInvalidFields(validateObject(rejection));
    }

    const validateForSubmit = () => {
        if (submitting) {
            setInvalidFields(validateObject(form));
        }
    }

    const submit = () => {
        if (submitting && !invalidFields.length) {
            setRejection({
                variables: {
                    loanApplicationId,
                    rejection: {
                        reason: form.reason,
                        details: form.details
                    }
                }
            });

            if (REASONS_WITH_NO_RETURN.find(reason => reason === form.reason)) {
                setShowThanksFeedback(true);
            } else {
                // todo Bloquear volta
                setShowHurryUp(true);
            }
        }
        setSubmitting(false);
    }

    useEffect(initializeForm, [rejection]);
    useEffect(validateForSubmit, [submitting]);
    useEffect(submit, [invalidFields]);

    const updateForm = (variableName: string, value: any, fieldName: string = variableName) => {
        if (value) {
            _.remove(invalidFields, invalidField => invalidField === fieldName);
        } else {
            setInvalidFields(validateObject({
                ...form,
                [variableName]: value
            }));
        }

        setForm({
            ...form,
            [variableName]: value
        });
    }

    if (showThanksFeedback) {
        return (
            <ThanksFeedbackPage />
        );
    }

    if (showHurryUp) {
        return (
            <HurryUpPage />
        );
    }

    return (
        <>
            <div className="feedback-page">
                <Title>queremos te ouvir</Title>

                <p className="feedback-page__subtitle">
                    Pra gente entender melhor, o que ainda faltou pra fazer um pedido?
                </p>

                <h3 className="mt-5 mb-3">
                    Escolha um motivo abaixo:
                </h3>

                <RadioButton
                    field={form.reason}
                    name="rejection"
                    label="melhores taxas"
                    value={RejectionReason.InterestRate}
                    onChange={(e) => updateForm("reason", e.value)}
                />

                <RadioButton
                    field={form.reason}
                    name="rejection"
                    label="melhor valor pré-aprovado"
                    value={RejectionReason.Value}
                    onChange={(e) => updateForm("reason", e.value)}
                />

                <RadioButton
                    field={form.reason}
                    name="rejection"
                    label="mais ou menos número de parcelas"
                    value={RejectionReason.Tenure}
                    onChange={(e) => updateForm("reason", e.value)}
                />

                <RadioButton
                    field={form.reason}
                    name="rejection"
                    label="preciso pensar melhor"
                    value={RejectionReason.StillThinking}
                    onChange={(e) => updateForm("reason", e.value)}
                />

                <RadioButton
                    field={form.reason}
                    name="rejection"
                    label="estou avaliando com outra empresa"
                    value={RejectionReason.AnotherProposal}
                    onChange={(e) => updateForm("reason", e.value)}
                />

                <RadioButton
                    field={form.reason}
                    name="rejection"
                    label="fiquei com dúvidas"
                    value={RejectionReason.InDoubt}
                    onChange={(e) => updateForm("reason", e.value)}
                />

                <h3 className="mt-5 mb-3">
                    Poderia nos dar mais detalhes do que você não gostou? (opcional)
                </h3>

                <InputTextarea
                    rows={5}
                    value={form.details || ""}
                    autoResize={true}
                    className="w-100"
                    onChange={(e) => updateForm("details", e.currentTarget.value)}
                />

            </div>
            <ButtonGroup className="feedback-page-footer">
                <Button
                    label="voltar"
                    className="p-button-info grid-button-return"
                    onClick={previousScreen}
                />

                <Button
                    label="enviar"
                    className={`${invalidFields.length ? 'p-button-secondary' : ''} grid-button-forward`}
                    onClick={async () => setSubmitting(true)}
                />
            </ButtonGroup>
        </>
    );
}

export default FeedbackPage;
